export default "__VITE_ASSET__yhDJeBiH__"